export interface CtaButtonProps {
  label: string;
  disabled: boolean;
  loading: boolean;
  onClick: () => void;
}

export function CtaButton({ label, disabled, loading, onClick }: CtaButtonProps) {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className="w-full font-medium text-[18px] transition-all duration-150 cta-btn"
      style={{
        padding: '12px 24px',
        lineHeight: '28px',
        borderRadius: 'var(--t-cta-radius)',
        background: 'var(--t-cta-bg)',
        color: 'var(--t-cta-text)',
        opacity: disabled ? 0.4 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
    >
      <span className="flex items-center justify-center gap-2">
        {label}
        {loading && (
          <div style={{
            width: 18, height: 18,
            border: '2px solid currentColor',
            borderTopColor: 'transparent',
            borderRadius: '50%',
            animation: 'nramp-spin 0.8s linear infinite',
            opacity: 0.6,
          }} />
        )}
      </span>
    </button>
  );
}
